import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { fuseAnimations } from '@fuse/animations';

import { NoteDialogComponent } from '../../note-dialog/note-dialog.component';
import { NoteService } from '../../../../../shared/services/note.service';
import { IParentEntity } from 'app/shared/interfaces/entity';
import { Note } from 'app/shared/models/note';
import { SubjectNote } from 'app/shared/models/subject-note';
import { TaskNote } from 'app/shared/models/task-note';

@Component({
    selector: 'notes-main-sidenav',
    templateUrl: './main-sidenav.component.html',
    styleUrls: ['./main-sidenav.component.scss'],
    animations: fuseAnimations,
})
export class NotesMainSidenavComponent implements OnInit, OnDestroy {
    types: any[];
    filters: any[];
    labels: any[];
    parent: IParentEntity;
    selectedAccount: string;
    dialogRef: any;
    baseUrl: string;

    onTypesChanged: Subscription;
    onFiltersChanged: Subscription;
    onParentChanged: Subscription;

    @Input() readOnly = false;

    constructor(
        private noteService: NoteService,
        public dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.onTypesChanged =
            this.noteService.onTypesChanged
                .subscribe((types) => {
                    this.types = types;
                });

        this.onFiltersChanged =
            this.noteService.onFiltersChanged
                .subscribe((filters) => {
                    this.filters = filters;
                });

        this.onParentChanged =
            this.noteService.onParentChanged
                .subscribe((parent) => {                    
                    this.parent = parent;
                    this.baseUrl = `/notes/${parent.type}/${parent.uid}`;
                });
    }

    ngOnDestroy() {
        if (this.onTypesChanged) this.onTypesChanged.unsubscribe();
        if (this.onFiltersChanged) this.onFiltersChanged.unsubscribe();
        if (this.onParentChanged) this.onParentChanged.unsubscribe();
    }

    addDialog() {
        this.dialogRef = this.dialog.open(NoteDialogComponent, {
            data: {
                note: (this.parent.type.toLowerCase() === 'task') ? new TaskNote(this.parent.id, new Note()) : new SubjectNote(this.parent.id, new Note()),
                parent: this.parent,
                readOnly: false,
            },
            disableClose: true,
            autoFocus: false,
        });
    }
}
